"use strict";
// list of quarantine reasons logiwa accepts
// https://developer.logiwa.com/?id=5e5eca6fe6466c26348a0e72
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuarantineResult = exports.QuarantineReason = void 0;
var QuarantineReason;
(function (QuarantineReason) {
    QuarantineReason["DAMAGED"] = "DAMAGED";
    QuarantineReason["EXPIRED"] = "EXPIRED";
    QuarantineReason["HOLD_CUSTOMER_REQUEST"] = "HOLD_CUSTOMER_REQUEST";
    QuarantineReason["MERCHANT_QUARANTINED"] = "MERCHANT_QUARANTINED";
    QuarantineReason["MISSING"] = "MISSING";
    QuarantineReason["PAST_SSD"] = "PAST_SSD";
    QuarantineReason["QUARANTINED"] = "QUARANTINED";
    QuarantineReason["REVIEW"] = "REVIEW";
})(QuarantineReason || (exports.QuarantineReason = QuarantineReason = {}));
var QuarantineResult;
(function (QuarantineResult) {
    QuarantineResult["SUCCESS"] = "SUCCESS";
    QuarantineResult["PARTIAL_SUCCESS"] = "PARTIAL_SUCCESS";
    QuarantineResult["FAILED"] = "FAILED";
})(QuarantineResult || (exports.QuarantineResult = QuarantineResult = {}));
//# sourceMappingURL=WarehouseQuarantine.js.map